import { Injectable, Injector } from '@angular/core';

import { Alert } from './alert';
import { CrudService } from '@mango/core';
import { Subject } from 'rxjs/internal/Subject';
import * as signalR from "@aspnet/signalr";

@Injectable()
export class AlertService extends CrudService<Alert> {

    constructor(injector: Injector) { 
        super(Alert, injector); 
        this.setupHubConnection(); 
    }

    hubSubject: Subject<any> = new Subject<any>();

    private setupHubConnection() {

        const connection = new signalR.HubConnectionBuilder().withUrl('/ws/alerts').build();

        connection.on('AlertBroadcast', () => {
            this.hubSubject.next();
        });

        connection.onclose((err?: Error) => {
            if(err) {
                console.log(err);
            }
            else {
                this.hubSubject.complete();
            }
        });

        connection.start();
    }

}
